import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DigitalInputGlyph = /*#__PURE__*/createElement("g", {
  id: "digital_input"
}, /*#__PURE__*/createElement("path", {
  d: "M62,67.5H20.6c-2.5,0-4.5-2-4.5-4.5v-8.5h3V63c0,0.8,0.7,1.5,1.5,1.5H62c0.8,0,1.5-0.7,1.5-1.5v-8.5h3V63 C66.5,65.5,64.5,67.5,62,67.5z"
}), /*#__PURE__*/createElement("polygon", {
  points: "49.8,47 41.5,55.2 33.3,47 31,49.3 41.5,59.8 52.1,49.3 \t"
}), /*#__PURE__*/createElement("path", {
  d: "M40.1,32.4c0,7.8,0,15.7,0,23.5c0,1.9,3,1.9,3,0c0-7.8,0-15.7,0-23.5C43.1,30.5,40.1,30.5,40.1,32.4L40.1,32.4z"
}), /*#__PURE__*/createElement("polygon", {
  points: "66.1,32.6 57.7,40.9 49.5,32.6 47.2,34.9 57.7,45.5 68.4,34.9 \t"
}), /*#__PURE__*/createElement("path", {
  d: "M56.3,20c0,7.2,0,14.4,0,21.5c0,1.9,3,1.9,3,0c0-7.2,0-14.4,0-21.5C59.3,18.1,56.3,18.1,56.3,20L56.3,20z"
}), /*#__PURE__*/createElement("polygon", {
  points: "34.5,32.6 26.1,40.9 17.9,32.6 15.6,34.9 26.1,45.5 36.8,34.9 \t"
}), /*#__PURE__*/createElement("path", {
  d: "M24.7,20c0,7.2,0,14.4,0,21.5c0,1.9,3,1.9,3,0c0-7.2,0-14.4,0-21.5C27.7,18.1,24.7,18.1,24.7,20L24.7,20z"
}));
const DigitalInput = createSvg({
  name: 'digital_input',
  path: DigitalInputGlyph
});

export default DigitalInput;
export { DigitalInputGlyph };
